// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'

import 'mint-ui/lib/style.css'

import Mint from 'mint-ui'

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

axios.defaults.baseURL = '/wechat'

Vue.use(Mint);

//picker popup遮罩防穿透
const maskHandler = (e) => {
    e.preventDefault();
};
Vue.directive('roll', {
    componentUpdated(el, binding) {
        if (binding.visible) {
            document.getElementsByTagName('body')[0].addEventListener('touchmove', maskHandler, { passive: false });
        } else {
            document.getElementsByTagName('body')[0].removeEventListener('touchmove', maskHandler, { passive: false });
        }
    }})

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});






// WEBPACK FOOTER //
// ./src/main.js